import { render, staticRenderFns } from "./PlantShow.vue?vue&type=template&id=0cb2b21c&scoped=true"
import script from "./PlantShow.vue?vue&type=script&lang=ts"
export * from "./PlantShow.vue?vue&type=script&lang=ts"
import style0 from "./PlantShow.vue?vue&type=style&index=0&id=0cb2b21c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2b21c",
  null
  
)

export default component.exports